import { RouteConfig } from "vue-router";

export const REmployerServicesExtensionTemplate: RouteConfig = {
  path: ":employeeId(\\d+)",
  name: "EmployerServicesExtensionTemplate",
  component: () =>
    import(
      /* webpackChunkName: "employer-services-extension-template" */
      "./VEmployerServicesExtensionTemplate.vue"
    ),
  meta: {
    title: "Back",
    backLink: "/services/extension",
    version: 2,
  },
};
